import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { format } from 'date-fns'
import { zhTW } from 'date-fns/locale'
import { AdImageBatch } from '@/hooks/useAdImageBatches'
import ActionCell from './ActionCell'

export const columns: ColumnDef<AdImageBatch>[] = [
  {
    accessorKey: 'batch_name',
    header: '批次名稱',
    cell: ({ row }) => {
      return <div className="font-medium">{row.original.batch_name}</div>
    },
  },
  {
    accessorKey: 'description',
    header: '描述',
    cell: ({ row }) => {
      return <div className="text-muted-foreground">{row.original.description || '-'}</div>
    },
  },
  {
    accessorKey: 'overlay_interval_ms',
    header: '覆蓋間隔',
    cell: ({ row }) => (
      <Badge variant="outline">{Math.round(row.original.overlay_interval_ms / 1000)} 秒</Badge>
    ),
  },
  {
    accessorKey: 'items',
    header: '圖片數量',
    cell: ({ row }) => {
      const activeItems = row.original.items.filter((item) => item.is_active)
      return <Badge variant="secondary">{activeItems.length} 張圖片</Badge>
    },
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      return row.original.is_active ? (
        <Badge className="bg-green-500">啟用</Badge>
      ) : (
        <Badge variant="secondary">停用</Badge>
      )
    },
  },
  {
    accessorKey: 'created_at',
    header: '建立時間',
    cell: ({ row }) => {
      return format(new Date(row.original.created_at), 'yyyy/MM/dd HH:mm', {
        locale: zhTW,
      })
    },
  },
  {
    id: 'actions',
    header: '操作',
    cell: ({ row, table }) => {
      return <ActionCell batch={row.original} onRefresh={table.options.meta?.onRefresh} />
    },
  },
]
